











import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ErrorPage',
  layout: 'error',
  props: {
    error: {
      type: Object,
      required: true,
    },
  }
});
